import { logger } from '@/lib/telemetry/logger';
import type { AnalyticsProvider } from '../types';

declare global {
  interface Window {
    twq?: (command: 'event', eventId: string, properties: Record<string, unknown>) => void;
  }
}

export function createXAdsProvider(): AnalyticsProvider {
  let accountId: string | null = null;

  return {
    // The existing production-only XAdsPixel owns loading and configuration.
    async initialize(): Promise<void> {},
    checkGate: (): boolean => false,
    getConfig: (): Record<string, unknown> => ({}),
    getExperiment: (): { value: null; ruleID: string } => ({ value: null, ruleID: '' }),
    identifyUser(userId: string): void {
      accountId = userId;
    },
    shutdown(): void {
      accountId = null;
    },
    trackEvent(name: string, properties: Record<string, unknown>): void {
      if (typeof window === 'undefined' || window.twq === undefined) return;
      if (name !== 'auth_method_used' || properties.isNewUser !== true) return;
      if (accountId === null || accountId === '') {
        logger.warn('X signup conversion skipped: missing account identity', {
          eventName: name,
        });
        return;
      }
      window.twq('event', 'tw-rf3oa-rg68d', { conversion_id: `signup:${accountId}` });
    },
  };
}
